import Message from 'shared_components/message';
import { axiosPhase2API, axiosLabAPI } from 'services/axios';
import HttpCodeMessage from 'shared_components/message_http_status';
import { API_GET_METHOD, API_POST_METHOD, API_PUT_METHOD } from 'global_config/constant-global';
import { showMessage } from 'services/settings/message';

export async function fetchSectionItems() {
	let sectionItems = [];

	try {
		const response = await axiosLabAPI({
			method: API_GET_METHOD,
			url: 'settings/section',
		});

		const { data } = response;
		sectionItems = data.RECORDS;
	} catch (e) {
		showMessage(e);
	}

	return sectionItems;
}

export async function createSectionItems(payload) {
	let createdSection;

	try {
		const response = await axiosLabAPI({
			method: API_POST_METHOD,
			url: 'settings/section',
			data: {
				p_section_name: payload.sectionName,
				p_section_code: payload.sectionCode,
				p_section_sort: payload.sectionSort,
				p_is_active: payload.is_active,
			},
		});

		const { data } = response;
		createdSection = data;
	} catch (e) {
		showMessage(e);
	}
	return createdSection;
}

export async function updateSectionItems(payload) {
	let updatedSection;

	try {
		const content = {
			method: API_PUT_METHOD,
			url: 'settings/section',
			data: {
				p_section_id: payload.sectionID,
				p_section_name: payload.sectionName,
				p_section_code: payload.sectionCode,
				p_section_sort: payload.sectionSort,
				p_is_active: payload.is_active,
			},
		};

		const response = await axiosLabAPI(content);
		const { data } = response;
		updatedSection = data;
	} catch (e) {
		showMessage(e);
	}

	return updatedSection;
}

export async function applySorting(payload) {
	let sortResponse;
	const url = `settings/sectionsorting`;

	try {
		const content = {
			method: API_PUT_METHOD,
			url,
			data: {
				p_section_sorting_array: JSON.stringify(payload)
			},
		};

		const response = await axiosLabAPI(content);
		const { data } = response;

		sortResponse = data;

		// Show success message from API response
		if (data && data.STATUSCODE === 200 && data.MESSAGE) {
			Message.success({ message: data.MESSAGE });
		}
	} catch (error) {
		showMessage(error);
	}

	return sortResponse;
}
